// Copyright (c) 2023, iPivot, Corp.
'use strict'

const axoniusTheme = require('./themes/axonius')
const cxRecon = require('./themes/cxRecon')
const defaultTheme = require('./themes/default')
const dragonflyDarkTheme = require('./themes/dragonflyDark')
const dragonflyLightTheme = require('./themes/dragonflyLight')
const quantumXchangeTheme = require('./themes/quantumXchange')
const onyxDefenseTheme = require('./themes/onyxDefense')
const glasswingDarkTheme = require('./themes/glasswingDark')
const glasswingLightTheme = require('./themes/glasswingLight')

/* Each theme module carries its own `variant` ('dark' or 'light'); it is lifted onto the
 * entry here so callers can pick a variant without loading every theme's colors.
 */
const IMPLEMENTED_THEMES = [
    { id: 'axonius', name: 'Axonius', theme: axoniusTheme },
    { id: 'cxRecon', name: 'CX Recon', theme: cxRecon },
    { id: 'default', name: 'Unbranded', theme: defaultTheme }, //eslint-disable-line id-blacklist
    { id: 'dragonflyDark', name: 'Dragonfly Cyber - Dark', theme: dragonflyDarkTheme },
    { id: 'dragonflyLight', name: 'Dragonfly Cyber - Light', theme: dragonflyLightTheme },
    { id: 'quantumXchange', name: 'Quantum Xchange', theme: quantumXchangeTheme },
    { id: 'onyxDefense', name: 'Onyx Defense', theme: onyxDefenseTheme },
    { id: 'glasswingDark', name: 'Dark', theme: glasswingDarkTheme },
    { id: 'glasswingLight', name: 'Light', theme: glasswingLightTheme },
].map(entry => Object.assign({ variant: entry.theme.variant }, entry))

module.exports.THEME_VARIANTS = [ 'dark', 'light' ]

module.exports.getDefaultTheme = () => IMPLEMENTED_THEMES.find(theme => theme.id === 'default')

module.exports.getTheme = themeId => IMPLEMENTED_THEMES.find(theme => theme.id === themeId)

/**
 * Pick a theme entry from a list of candidates, preferring an explicit id over a
 * dark/light variant.
 *
 * Everything fed in here is untrusted: `themes` comes from a registry list that may
 * name a theme that no longer exists (getTheme returns undefined for those), and the
 * id/variant come from user settings that may be stale. Each step is guarded and the
 * chain always ends somewhere real, because handing an undefined entry back to the
 * caller blanks the entire UI.
 *
 * @param {object[]} themes Candidate entries, as returned by availableThemes().
 * @param {object} pref
 * @param {string} [pref.themeId] Explicit theme id; wins when it is still available.
 * @param {string} [pref.variant] 'dark' or 'light'.
 * @returns {object} A theme entry, never undefined.
 */
module.exports.resolveTheme = (themes = [], { themeId, variant } = {}) =>
    themes.find(entry => entry && entry.id === themeId) ||
    themes.find(entry => entry && entry.variant === variant) ||
    themes.find(entry => entry) ||
    module.exports.getDefaultTheme()

module.exports.imagePath = `${__dirname}/images`
module.exports.imageUrl = '/theme_images'
